export default __webpack_public_path__ + "static/media/roadmap_dot.09ea4b95.svg";